import { slugs } from '@/constants/slugs'
import { TranslateFunction } from '@/utils/translate/translate-client'
import { GiveawayConfig } from '../../types'
import { createBaseConfig, createStandardTabs, createStandardSteps } from '../shared'

export const getKingOfKingsConfig = (t: TranslateFunction): GiveawayConfig => {
  return createBaseConfig({
    theatricalSlug: slugs.kingOfKings,
    heroTitle: t(
      'giveawayHeroTitleKingOfKingsV2',
      'Watch The King of Kings in Theaters and enter to Win a $100K Unforgettable Journey!',
    ),
    logoUrl: 'https://images.angelstudios.com/image/upload/v1738950570/TKoK_Logo-White_1_odfsyb.webp',
    inTheatersText: t('inTheatersKingOfKings', 'In theaters Apr. 11th'),

    share: {
      shareText:
        'The upcoming @AngelStudios movie King of Kings in theaters on Apr. 11th. Pre-order tickets for as chance to Win the $100k Giveaway!',
      hashtag: '',
      shareImage: 'v1738950712/king-of-kings-giveaway-hero-vert-02_ztlgjf.webp',
      shareImageMobile: 'v1738950712/king-of-kings-giveaway-hero-vert-02_ztlgjf.webp',
    },

    rulesLink: 'https://bit.ly/AngelFilmsKingofKings',
    ticketFlow: {
      congratsModal: {
        text: t(
          'tkokCongratsModalText',
          "You've earned entries for your chance to win the $100,000 unforgettable journey! Complete your checkout to secure your entries.",
        ),
        image: '/v1739309825/image-sq_mhezub.webp',
        alt: '',
      },
      noShowtimes: {
        image: '/v1739305001/f4b3c97cc47829425f60dc6eb2d9fb7b_jxudh8.webp',
        text: t(
          'tkokNoShowtimes',
          "We're adding new theaters every week. While you wait, pre-order tickets today for your chance to win the $100k Unforgettable Journey Giveaway!",
        ),
      },
      reservationCompletePage: {
        image: '/v1739305001/f4b3c97cc47829425f60dc6eb2d9fb7b_jxudh8.webp',
        alt: '',
        text: t(
          'kokReservationCompleteText',
          "You've earned entries for your chance to win the $100,000 unforgettable journey!",
        ),
      },
    },
    videoImage: '/v1738950773/kok-video-cover-img-01_o8d3ng.webp',

    steps: [
      ...createStandardSteps(t),
      {
        title: t('multiplyYourChances', 'Multiply Your Chances'),
        description: t(
          'preOrderTicketsStep3DescriptionLastRodeoV3',
          "The earlier you pre-order, the more bonus entries you'll get for The Last Rodeo Giveaway",
        ),
      },
    ],

    tabs: createStandardTabs(t),

    prizes: [
      {
        image: 'https://images.angelstudios.com/image/upload/v1739420863/imperial-outdoors-trailer-img-01_yft8nz.jpg',
        alt: 'Imperial Outdoors Xplore X195 Travel Trailer',
        title: 'Imperial Outdoors Xplore X195 Travel Trailer',
        value: '$147,000',
        url: 'https://imperial-outdoors.com/',
        sponsorName: 'Imperial Outdoors',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1727735729/Homestead/prizes/bitcoin-01.jpg',
        alt: 'Bitcoin',
        title: '$100,000 in BitCoin',
        value: '$100,000',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1739420803/f150-truck-img-01_r9wr47.jpg',
        alt: 'Ford F150 Raptor',
        title: 'Ford F150 Raptor',
        value: '$83,000',
        url: 'https://www.ford.com/trucks/f150/models/f150-raptor/',
        sponsorName: 'Ford',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1744660175/Z252_mower_Salina_KS_2023_071-min_zqwzem.jpg',
        alt: 'Kubota Zero Turn Mower',
        title: 'Kubota - Z252KW-54 - Zero Turn Mower',
        value: '$7,499',
        url: 'https://www.kubotausa.com/',
        sponsorName: 'Kubota',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1746822684/the-last-rodeo/Clean_WholeBeefStorage-lowres.jpg',
        alt: 'Whole Cow',
        title: 'Whole Cow of Meat with Freezer',
        value: '$6,876',
        sponsorName: 'Whole Cow',
        representativePrizeShown: true,
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1746822614/the-last-rodeo/0009305_zeon-xp-14-s-110140_625-lowres.jpg',
        alt: 'Warn Winch',
        title: 'Warn ZEON XP 14-S Winch',
        value: '$3,200',
        url: 'https://www.warn.com/',
        sponsorName: 'Warn',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1746822615/the-last-rodeo/ai-upscale-recovery-kit-lowres.jpg',
        alt: 'Vehicle Recovery Kit',
        title: 'Factor 55 - Vehicle Recovery Kit',
        value: '$1,640',
        url: 'https://factor55.com/',
        sponsorName: 'Factor 55',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1746822614/the-last-rodeo/ultra-hook-lowres.jpg',
        alt: 'Red Ultra Hook',
        title: 'Factor 55 - Red Ultra Hook',
        value: '$280',
        url: 'https://factor55.com',
        sponsorName: 'Factor 55',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1739420647/AdobeStock_1106386350_y5swrt.jpg',
        alt: 'Gift Card for Ariat Denim',
        title: 'Any Two Pair of Denim Up to $140 Each',
        value: '$280',
        url: 'https://www.ariat.com',
        sponsorName: 'Ariat',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1747153338/F23_MNS_WEST_Montana_Copenhaver_2471_h2zncq.png',
        alt: 'Gift Card for Ariat Cowboy Boots',
        title: 'Any Two Pair of Boots Up to $270 Each',
        value: '$560',
        url: 'https://www.ariat.com',
        sponsorName: 'Ariat',
      },
    ],
    galleryImages: [
      {
        src: 'https://images.angelstudios.com/image/upload/v1738951554/KOK_Google-Search-Images_1.91x1_V3_n8qoqx.jpg',
        alt: 'King of Kings Images',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1738951554/KOK_Google-Search-Images_1.91x1_V4_bssggs.jpg',
        alt: 'King of Kings Images',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1738951555/KOK_Google-Search-Images_1.91x1_V5_bztj2y.jpg',
        alt: 'King of Kings Images',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1738951556/KOK_Google-Search-Images_1.91x1_V6_io7abi.jpg',
        alt: 'King of Kings Images',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1738951555/KOK_Google-Search-Images_1.91x1_V7_jhpkuw.jpg',
        alt: 'King of Kings Images',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1738951555/KOK_Google-Search-Images_1.91x1_V8_enrlcz.jpg',
        alt: 'King of Kings Images',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1738951556/KOK_Google-Search-Images_1.91x1_V9_uusowp.jpg',
        alt: 'King of Kings Images',
      },
      {
        src: 'https://images.angelstudios.com/image/upload/v1738951556/KOK_Google-Search-Images_1.91x1_V10_ttuohl.jpg',
        alt: 'King of Kings Images',
      },
    ],
    partnerLogos: [],
  })
}
